import { render } from "./SiswaView.vue?vue&type=template&id=81dbaa6e"
import script from "./SiswaView.vue?vue&type=script&lang=js"
export * from "./SiswaView.vue?vue&type=script&lang=js"

import "./SiswaView.vue?vue&type=style&index=0&id=81dbaa6e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__